import React from 'react';

const NotificationContext = React.createContext({
    notify: () => {},
    notification: [],
});

export default NotificationContext;